@for (option of options(); track option.value) {
    <button (click)="value.set(option.value)"
            [attr.aria-pressed]="value() === option.value"
            [class.active]="value() === option.value"
            type="button">
        <span class="label">
            <span class="dot" [style.background]="option.color ?? '#6b7280'"></span>{{ option.label }}
        </span>
        <span class="count">{{ option.count ?? '–' }}</span>
    </button>
}
